import { Injectable } from '@angular/core';
import { BehaviorSubject, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { Toast, ToastExtended } from '../models/toast.model';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private _toasts$ = new BehaviorSubject<ToastExtended[]>([]);
  toasts$ = this._toasts$.asObservable();

  idCounter = 0;

  addToast(newToast: Toast): void {
    const newExtendedToast: ToastExtended = { ...newToast, id: this.idCounter };
    this.idCounter += 1;
    this._toasts$.next([...this._toasts$.getValue(), newExtendedToast]);
    if (!newToast.isPersisted) {
      timer(newToast.duration || 4000)
        .pipe(take(1))
        .subscribe(() => this.removeToast(newExtendedToast));
    }
  }

  removeToast(newToast: ToastExtended) {
    this._toasts$.next(this._toasts$.getValue().filter((toast) => toast.id !== newToast.id));
  }
}
